const isProd = process.env.NODE_ENV === 'production';
export const API_ENDPOINT = isProd ? 'https://api.marketbangla.com' : 'http://localhost:8000';
